// idle.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
//import { Keepalive } from '@ng-idle/keepalive';
import { BehaviorSubject, Subscription } from 'rxjs';

import { NotificationService } from './notification.service';
import { ModalAlertProp, NotificationTypeEnum } from 'src/app/models/config-view-models';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { Keepalive } from '@ng-idle/keepalive';
import { EventLogInvalidUserCreateRequest } from '../models/viewmodels';
import { UserInfoService } from './user-info.service';
import { EventLogService } from './event-log.service';

@Injectable({ providedIn: 'root' })
export class IdleService implements OnDestroy {
  // Example idle settings (in seconds)
  private idleTimeout = Number(environment.inactivityTimeout);    
  private timeoutFrequency = 30; //Drives timeout countdown
  //private pingInterval = 120;   //Unused for now

  // Observable for global countdown state
  private _countdown$ = new BehaviorSubject<number>(0);
  countdown$ = this._countdown$.asObservable();

  // Flag to open the warning modal only once per idle cycle
 // private isWarningModalOpen = false;
  private isWatching = false;  // Are we currently tracking?

  // Subscriptions
  private idleEndSub?: Subscription;
  private timeoutWarningSub?: Subscription;
  private timeoutSub?: Subscription;
  private keepaliveSub?: Subscription;

  //Warning Modal Reference
  currentWarningModalRef: HTMLIonModalElement | undefined;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private notificationService: NotificationService,
    private authService: AuthService,
    private userInfoService: UserInfoService,
    private eventLogService: EventLogService
  ) {
    // 1) Basic ng-idle configuration
    //console.log(`IdleService: Configuring idle timeout: ${this.idleTimeout} seconds, with a timeout period of ${this.timeoutFrequency} seconds.`);
    this.idle.setIdle(this.idleTimeout);
    this.idle.setTimeout(this.timeoutFrequency);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idleEndSub = this.idle.onIdleEnd.subscribe(() => { //Do sometthing once the user is active again
      this._countdown$.next(0);
    });
    // 2) Subscribe to idle events

    this.timeoutWarningSub = this.idle.onTimeoutWarning.subscribe(async (countdown: number) => {//Do something each second of the countdown

        this._countdown$.next(countdown);
        if (this.timeoutFrequency == countdown && !document.hidden && document.hasFocus()) { //Ignore modal one it's first opened, or focus is out of quotify's webpage

          const modalProp: ModalAlertProp = {
            header: 'Inactivity Warning',
            message: `You will be logged out once the counter runs out. Please save any unsaved work.`,
            notificationType: NotificationTypeEnum.Warning,
            counter: countdown,
          };
          this.currentWarningModalRef = await this.notificationService.presentAlertModal(modalProp);
      }
    });

    this.timeoutSub = this.idle.onTimeout.subscribe(() => { //Do something once countdown is elapsed


      console.log('User timed out due to inactivity - logging out now...');
          this.notificationService.PresentTypedToast(
            'Logged out due to inactivity.',
            NotificationTypeEnum.Info,
            5000
          );
          this.forceLogout();
    });

    /*
    this.keepalive.interval(this.pingInterval);
    this.keepaliveSub = this.keepalive.onPing.subscribe(() => { // DO something at any set interval
      // e.g. refresh token
      // this.authService.refreshToken();
    });
    */
  }

  /**
   * Start or re-start idle tracking
   */
  watch() {
    if (!this.isWatching) {
      this.idle.watch();
      this.isWatching = true;
      console.log('IdleService: STARTED watching for inactivity');
    }
    // Reset UI state
    this._countdown$.next(0);
  }

  /**
   * Stop idle tracking
   */
  stop() {
    if (this.isWatching) {
      this.idle.stop();
      this.isWatching = false;
      console.log('IdleService: STOPPED watching');
    }
    // Reset UI
    this._countdown$.next(0);
  }

  forceLogout() {
    // Usually you'd do more logic here
    let currentUserId = '';

    try { 
      currentUserId = this.userInfoService.getAppUser()?.UserId?.toString().trim() ?? '0';

      var stack = new Error()?.stack;
      var evt: EventLogInvalidUserCreateRequest = {
        ExpectedValue: Number(currentUserId),
        ActualValue: Number(currentUserId),
        RequestUrl: 'IdleService.forcelogout()',
        LocationUrl: window.location.href,
        CallStack: 'IdleService.forcelogout() - ' + stack,
      };
      this.eventLogService.createInvalidUserLogoutEvent(evt);

    } catch (e) {
      console.error('error when logging invalid user', currentUserId);
    }
    
    this.stop(); // stop idle
    this.authService.logout(); // e.g., remove tokens, navigate to /login, etc.
  }


  ngOnDestroy() {
    // Cleanup
    this.idleEndSub?.unsubscribe();
    this.timeoutWarningSub?.unsubscribe();
    this.timeoutSub?.unsubscribe();
    this.keepaliveSub?.unsubscribe();
  }
}
